import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';
import { addRestaurantsToLoyaltyProgram, editEntityField } from '../../../actions';

class LoyaltyProgramRestaurantsEditor extends Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        const { loyaltyProgramId, entity, addRestaurantsToLoyaltyProgram } = this.props;
        addRestaurantsToLoyaltyProgram(loyaltyProgramId, entity.restaurants);
        event.preventDefault();
    }

    render() {
        const { entity, meta } = this.props;

        const lp = entity || {};

        // const restaurantsOptions = meta.restaurants.map(rest => ({
        //     value: rest.id,
        //     text: rest.name
        // }));
        const restaurantsOptions = [];

        return (
            <Form onSubmit={this.handleSubmit}>

                <Form.Field required>
                    <label>{i18next.t('restaurants')}</label>
                    <Dropdown
                        placeholder={i18next.t('restaurants')}
                        required
                        fluid
                        selection
                        options={restaurantsOptions}
                        multiple
                        value={lp.restaurants || []}
                        onChange={(e, { value }) => this.props.editEntityField('restaurants', value)}
                    />
                </Form.Field>

                <Button primary type='submit' disabled={!lp.restaurants}>
                    {i18next.t('save')}
                </Button>
            </Form>
        );
    }
}

LoyaltyProgramRestaurantsEditor.propTypes = {
    loyaltyProgramId: PropTypes.any,
    meta: PropTypes.object,
    addRestaurantsToLoyaltyProgram: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object,
    
};

const mapStateToProps = (state) => {
    const { meta } = state;
    const { entity } = state.editor;

    return { meta, entity };
};

export default connect(mapStateToProps, {
    addRestaurantsToLoyaltyProgram,
    editEntityField,
})(LoyaltyProgramRestaurantsEditor);
